import JSBridgeCore from './core';

function _requestCallback(resolve, reject) {
  return (respones) => {
    if (!respones || respones.code !== '000000') {
      reject(respones);
    } else {
      resolve(respones);
    }
  };
}

function use(target) {
  JSBridgeCore.init(target);
}

function request(method, data) {
  return new Promise((resolve, reject) => {
    try {
      const callback = _requestCallback(resolve, reject);
      JSBridgeCore.request(method, data, callback);
    } catch (error) {
      reject(error);
    }
  });
}

function requestSync(method, data) {
  try {
    const resp = JSBridgeCore.syncRequest(method, data);
    return JSON.parse(resp);
  } catch (error) {
    console.error('requestSync error', error);
  }
}

function send(method, data) {
  JSBridgeCore.sendMessage(method, data);
}

function publish(method, data) {
  JSBridgeCore.publishMessage(method, data);
}

function subscribe(method, callback) {
  JSBridgeCore.subscribe(method, callback);
}

function unsubscribe(method, callback) {
  JSBridgeCore.unsubscribe(method, callback);
}

function emit(method, params) {
  JSBridgeCore.emit(method, params);
}

const JSBridgeApi = {
  use,
  request,
  requestSync,
  send,
  publish,
  emit,
  subscribe,
  unsubscribe
};

export default JSBridgeApi;
